import { formatRFC3339, lightFormat, parse, parseISO } from 'date-fns';

export const FORMAT_DATE_TIME = "dd.MM.yyyy HH.mm"
export const FORMAT_TIME = "HH.mm"
export const FORMAT_DATE = "dd.MM.yyyy"
export const FORMAT_PARAM_DATE_TIME = "yyyy-MM-dd'T'HH:mm:ss"
export const DB_FORMAT_DATE = "yyyy-MM-dd HH:mm:ss"
export const SHIPMENT_FORMAT_DATE = "yyyyMMddHHmmss"

export function displayTime(date: Date): string | undefined {
    return date && lightFormat(date, FORMAT_TIME)
}

export function formatTime(date: Date): string | undefined {
    return date && lightFormat(date, FORMAT_TIME)
}

export function toDate(date: string): Date | undefined {
    return date ? parse(date, FORMAT_DATE, new Date()) : undefined;
}

export function displayDate(date: Date): string | undefined {
    return date && lightFormat(date, FORMAT_DATE)
}

export function formatDate(date: Date): string | undefined {
    return date && lightFormat(date, FORMAT_DATE)
}

export function toDateTime(date: string): Date | undefined {
    return date ? parse(date, FORMAT_DATE_TIME, new Date()) : undefined;
}

export function displayDateTime(date: Date): string | undefined {
    return date && lightFormat(date, FORMAT_DATE_TIME)
}

export function formatDateTime(date: Date): string | undefined {
    return date && lightFormat(date, FORMAT_DATE_TIME)
}

export function toDateTimeParam(date: Date): string | undefined {
    return date && parseISO(date)
}

export function displayDateTimeParam(date: Date): string | undefined {
    return date && formatRFC3339(date)
}

export function formatDateTimeParam(date: Date): string | undefined {
    return date && formatRFC3339(date)
}

export function dbFormatTime(date: Date): string | undefined {
    return date && lightFormat(date, DB_FORMAT_DATE)
}

export function shipmentFormatTime(date: Date): string | undefined {
    return date && lightFormat(date, SHIPMENT_FORMAT_DATE)
}
